import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    priceList: [],
    filter: [],
    zoomLvl: 1,
    mobile: (window.innerWidth <= 700),
    BasketLines: [],
    pointshop: false,
    isAvailableInYourCountry: false,
    pointBalance: 0,
    priceListFilterPills: [],
    searchResult: {
      show: false,
      result: [{globalProducts: []}],
    }
  },
  mutations: {
    loadingHandler(state, value) {
      state.loading = value;
    },
    applyPriceList(state, value) {
      state.priceList = value;
    },
    setFilter(state, value) {
      state.filter = value;
      if (typeof window.ajaxBasket != 'undefined') {
        window.ajaxBasket.refresh()
      }
    },
    forceLoadButtons(state) {
      window.ajaxBasket.refresh()
    },
    applyPoints(state, value) {
      state.pointBalance = value;
    },
    setMobile(state, value) {
      state.mobile = value;
      state.zoomLvl = window.devicePixelRatio
    },
    applyQuantityFromBasket(state, value) {
      state.BasketLines = [];
      value.forEach(element => {
        state.BasketLines.push({ id: element.productID, quantity: element.quantity, isSubscription: element.isSubscription })
      });
    },
    updateSingleProduct(state, val) {
      if (state.BasketLines.length > 0) {
        state.BasketLines.forEach(product => {
          if (product.id == val.productID) {
            product.quantity = val.currentQty;
          } else {
            state.BasketLines.push({ id: val.productID, quantity: val.currentQty, isSubscription: val.isSubscription })
          }
        })
      } else {
        state.BasketLines.push({ id: val.productID, quantity: val.quantity, isSubscription: val.isSubscription })
      }
    },
    setIsAvailableInYourCountry(state, value) {
      state.isAvailableInYourCountry = value;
    },
    applySearchResult(state, value) {
  
      state.searchResult.result = [{globalProducts: []}];
      state.filter = [];
      state.priceListFilterPills = [];
      state.searchResult.result = typeof value != 'undefined' && value.length > 0 ? value : state.searchResult.result;
      state.searchResult.show = true;
      state.loading = false;
      window.ajaxBasket.refresh()
    }
  },
  actions: {
    async checkCountryAvailability(context) {
    
    try {
        const response = await axios.get(basedir + '/ajaxRequestServlet?mode=PointWidget&payload={"pointShopModuleMode":"checkPointWidgetAvailability","isPointShop":"Y"}', {
          headers: {
            'Content-type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        });

        if (response.status === 200 && response.data.isPointWidgetAvailable !== undefined) {
          context.commit("setIsAvailableInYourCountry", response.data.isPointWidgetAvailable);
          return response.data.isPointWidgetAvailable;
        } else {
          context.commit("setIsAvailableInYourCountry", true);
          return true;
        } // Network error / 4xx / 5xx: do NOT treat as "country blocked".
      } catch (error) {
        context.commit("setIsAvailableInYourCountry", true);
        return true; // Network error / 4xx / 5xx: do NOT treat as "country blocked".
      }
    },
    async collectItemsFromSearchQuery(context, query) {
      context.state.loading = true;
      //await axios.get(window.basedir + "/ajaxRequestServlet?mode=FreeSearch&M_AttributeSet_ID=1000018&isPointShop=" + context.state.pointshop + "&isProductOverview=true", {params: {"searchString": query}}, {
     await axios.get(window.basedir + "/ajaxRequestServlet?mode=FreeSearch&isPointShop=" + context.state.pointshop + "&isProductOverview=true", {params: {"searchString": query}}, {
     
     
     
        headers: {
          'Content-type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        }
      }).then(response => {
        gtag('event', 'Shop search', {
          event_category: 'engagement',
          event_label: query,
        })
        if(window.hasFbq) {
          fbq('track', 'Search', {
            search_string: query
        });
        }
        if(window.hasReddit && window.redditPixelReady && typeof rdt === 'function') {
          rdt('track', 'Search', {
            conversionId: crypto.randomUUID?.() || String(Date.now())
          });
        }
      
      // map the response.data.productsByAttribute to the onStockProducts
      // remove the products or product variants that are that are not on stock
        // const onStockProducts = response.data.productsByAttribute.map(obj => ({
        //   ...obj,
        //   globalProducts: obj.globalProducts.map(g => ({
        //     ...g,
        //     products: g.products.filter(p => p.availability == 5 || p.availability == 2) // keep only on stock products and products that are set to "may not sell"
        //   })).filter(g => g.products.length > 0) //remove empty products groups
        // }));

        // context.commit('applySearchResult',onStockProducts)


        context.commit('applySearchResult',response.data.productsByAttribute)
      })
    },
    screenSize(context, val) {
      context.commit('setMobile', val)
    },
    updateFilter(context, val) {
      var tempArray = []
      val.forEach(el => {
        tempArray.push(el.attributeValueIds)
      })
      context.dispatch('setFilter', tempArray)
    },
    loadButtons(context) {
      context.commit("forceLoadButtons");
    },
    addOrRemoveQuant(context, val) {
      var qty = val.type == "plus" ? parseInt(val.currentQuant, 10) + 1 : parseInt(val.currentQuant, 10) - 1
      var payloadObj = {
        products: [{ productID: val.id, quantity: qty }],
        isPointShop: context.state.pointshop ? 'Y' : 'N'
      }
      var payload = encodeURIComponent(JSON.stringify(payloadObj))
      axios.get(window.basedir + "/ajaxRequestServlet?mode=UpdateQuantity&payload=" + payload, {
        headers: {
          'Content-type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        }
      }).then((response) => {
        var err = response.data && response.data.errorMessage
        var hasErr = typeof err === 'string' && err.length > 0
        if (!hasErr) {
          window.ajaxBasket.refresh()
        } else {
          alertify.logPosition("bottom right").closeLogOnClick(true).delay(0).error('<i style="color:#ff7070 !important;padding-right: 3px;" class="fa fa-exclamation-triangle" aria-hidden="true"></i>  ' + err);
        }

      }).catch(error => {
        alertify.logPosition("bottom right").closeLogOnClick(true).delay(0).error('<i style="color:#ff7070 !important;padding-right: 3px;" class="fa fa-exclamation-triangle" aria-hidden="true"></i>  ' + error.data.errorMessage);
      });
    },
    async refreshBasket(context, val) {
      if (typeof val != 'undefined') {
        context.commit("applyQuantityFromBasket", val)
      }
    },
    async updatePointShopWidget(context, val) {
      axios.get(basedir + '/ajaxRequestServlet?mode=PointWidget&payload={"pointShopModuleMode":"GetPoints","isPointShop":"Y"}', {
        headers: {
          'Content-type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        }
      }).then(response => {
        context.commit("applyPoints", response.data.points);
      })

    },
    async getPriceList(context, [showCatAttr, hideCatAttr]) { //uses ES6 argument destructuring to assign the Incoming arrays as variables
    //async getPriceList(context, val) {
      context.commit("loadingHandler", true);
     // await axios.post(basedir + '/ajaxRequestServlet?mode=Search', { isPointShop: context.state.pointshop, target: { products: { noOfResults: 99999, isProductOverview: true } }, attributeValueIds: val, blacklistedAttributeValueIds: valBlack}, {
      await axios.post(basedir + '/ajaxRequestServlet?mode=Search', { isPointShop: context.state.pointshop, target: { products: { noOfResults: 99999, isProductOverview: true } }, attributeValueIds: showCatAttr, blacklistedAttributeValueIds: hideCatAttr}, { //7507084
       
        headers: {
          'Content-type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        }
      }).then(response => {
        context.commit("applyPriceList", response.data.productsByAttribute)
        
        context.commit("setFilter", showCatAttr)
        context.commit("loadingHandler", false);
      })
    },
  },
  getters: {
    priceList: state => {
      return state.priceList;
    },
  }
})
